/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";

import { Button, Card, Col, Result, Row, Spin } from "antd";
import { useConfirmEmail } from "@/api/user";
import { NAV_LOGIN } from "@/constants";

/**
 * Email Confirmation Screen 
 * Reads a token from URL params and sends it back to the server to confirm it
 * @returns JSX.Element
 */
export const EmailConfirmationScreen = (): JSX.Element => {
  const { t } = useTranslation();
  const { token } = useParams();
  const confirmEmail = useConfirmEmail();
  const navigate = useNavigate();
  const { mutate: confirmEmailMutation } = confirmEmail;

  useEffect(() => {
    if (token) {
      confirmEmailMutation(token);
    }
    return () => {};
  }, [confirmEmailMutation, token]);

  
  const renderConfirmationResults = () => {
    if (confirmEmail.isSuccess) {
      return <>
        <Result
          status="success"
          title={t("email_confirmation.success")}
        />
        <Button
          className=""
          type="primary"
          onClick={() => navigate(NAV_LOGIN)}
        >
          {t("common.sign_in")}
        </Button>
      </> 
    } else if(confirmEmail.isError) {
      return <Result
        status="error"
        title={t("email_confirmation.error")}
      />
    }
    return <Result
      status="error"
      title={t("email_confirmation.warning")}
    />
  }
  
  // Before sending the token to the server - display nothing
  if (confirmEmail.isIdle) {
    return <></>
  }
  return (
    <Row align={"middle"} justify={"center"} className="w-100">
      <Col lg={10} xl={9} md={14} xs={24}>
        <Card title="User registration">
          {confirmEmail.isLoading ? (
            <div className="text-center">
              <Spin />
            </div>
          ) : renderConfirmationResults()
          }
        </Card>
      </Col>
    </Row>
  );
};
